import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlidesWideAdd: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="slides-wide-add"><path d="M6.75 19.25V8.75H21.25V19.25H6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 15.25H2.75V4.75H17.25V8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.75 14H14M14 14H16.25M14 14V11.75M14 14V16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSlidesWideAdd;
